import Loading from 'components/Loading';
import SphereViewer from 'components/SphereViewer';
import { FC, useEffect, useState } from 'react';
import { fileUrl } from 'api';
import { selectLightingSolutionState, selectRoomState } from 'store/roomSlice';
import { useAppSelector } from 'store/hooks';
import Text from 'components/ui/Text';
import classNames from 'classnames';

type ImageViewerWrapperProps = {
  loadingText: string;
  overlayText: string;
};

const ImageViewerWrapper: FC<ImageViewerWrapperProps> = ({
  loadingText,
  overlayText,
}) => {
  const [loading, setLoading] = useState(true);
  const [imageSrc, setImageSrc] = useState('');
  const [showOverLay, setShowOvelay] = useState(true);
  const currentLightingSolution = useAppSelector(selectLightingSolutionState);
  const currentRoom = useAppSelector(selectRoomState);

  useEffect(() => {
    if (currentLightingSolution) {
      const [image] = currentLightingSolution.roomImages;
      // const src = imageUrl(image).toString();
      const src = fileUrl(image);
      setImageSrc(src);
    }
  }, [currentLightingSolution]);

  const handleFirstDrag = () => (!showOverLay ? null : setShowOvelay(false));

  return (
    <>
      <div className="h-screen" onMouseDown={handleFirstDrag}>
        <SphereViewer
          imageSrc={imageSrc}
          minFov={currentRoom?.fieldOfView || 45}
          maxFov={currentRoom?.fieldOfView || 45}
          defaultZoomLvl={currentRoom?.fieldOfView || 45}
          navbar={[]}
          onImageLoadEnd={() => setLoading(false)}
          onImageLoadStart={() => setLoading(true)}
        />
        <div
          className={classNames(
            'absolute pointer-events-none inset-0 bg-opacity-20 bg-blue transition-opacity duration-300',
            'flex flex-col gap-6 items-center justify-center',
            showOverLay ? 'opacity-1' : 'opacity-0',
          )}
        >
          <Text className="text-white !text-[32px] text-center" bold>
            {overlayText}
          </Text>
        </div>
      </div>

      <Loading
        text={loadingText}
        className={loading ? '' : 'opacity-0 pointer-events-none'}
      />
    </>
  );
};

export default ImageViewerWrapper;
